import API from "../../services/API";
import axios from "axios";
import Endpoints from "../config/Endpoints";

export default {

    Submit: function (formID, submission) {
        let url = API.url(
            Endpoints.Forms.Submit,
            {form_id: formID}
        );

        let csrfToken = document.head.querySelector('meta[name="csrf-token"]').content

        return axios.post(url, submission
            , {
                headers: {
                    'X-CSRF-TOKEN': csrfToken,
                    'X-Requested-With': 'XMLHttpRequest'
                }
            })
            .then((res) => {
                return res.data.data;
            });
    }

}
